/**
 * @author Ariel
 * @date 2020-09-24
 * @desc 活动通知管理列表页配置
 */
import React from 'react'
import {component_tool} from '../../../../tool';
import moment from "moment";

let {WizModal, WizCard} = component_tool;
let componentName = 'activityMessage'

const columns = [
  {
    name: 'id',
    formItem: {type: 'hidden'}
  },
  {
    name: 'activityId',
    formItem: {type: 'hidden'}
  },
  {
    title: '公告标题',
    name: 'title',
    tableItem: {},
    searchItem: {}
  },
  {
    title: '公告状态',
    name: 'state',
    searchItem: {
      type: 'select'
    },
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'},
    ]
  },
  {
    title: '有效时间',
    name: 'messageTime',
    searchItem: {
      type: 'date~',
      format: 'YYYY-MM-DD'
    },
    tableItem: {
      render: (text, record) => {
        let {startTime, endTime} = record
        let value = startTime + ' ~ ' + endTime
        return <div>{value}</div>
      }
    }
  },
  {
    title: '公告状态',
    name: 'state',
    tableItem: {},
    dict: [
      {code: 1, codeName: '有效'},
      {code: 0, codeName: '无效'},
    ]
  },
]

const templateConfig = (e) => {
  let {activityId} = e
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['messageTime'] && value['messageTime'].length === 2) {
              value['startTime'] = moment(value['messageTime'][0]).format("YYYY-MM-DD")
              value['endTime'] = moment(value['messageTime'][1]).format("YYYY-MM-DD")
            }
            // delete value['messageTime']
            return value
          },
          buttonSort: ['add'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: {icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/interact/activity/activityMessage/activityMessageDetailAdd',
                  record: {activityId: activityId}
                }
              }
            },
          ]
        },
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort: ['update', 'contentPreview', 'enableOrDisable'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: {children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/interact/activity/activityMessage/activityMessageDetailUpd",
                record: {activityId: activityId}
              },
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: {children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: {'1': '禁用', '0': '启用',}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "打开" : "关闭"
                }该活动公告吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record['id'],
                      // ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "contentPreview",
            custom: true,
            params: {children: "内容预览"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  footer: null,
                  style: {minWidth: 700},
                  diy: (e) => {
                    let record = e && e['record']
                    return (
                      <WizCard title={record['title']}>
                        <div dangerouslySetInnerHTML={{__html: record['content']}}/>
                      </WizCard>
                    )
                  }
                }
              },
              formatParams: (rows, record, filters, callback) => {
                return {...record}
              }
            }
          },
        ]
      }
    }
  }
};

const apis = (activityId = []) => {
  return {
    list: {
      path: `${componentName}/list`,
      payload: {
        key: `${componentName}@list`,
        apiParams: {activityId: activityId}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {}
      }
    },
  }
}

let reduxTemplateConfig = (args) => {
  let {activityId} = args
  return {
    apis: apis(activityId),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
